import { useEffect } from "react";

/**
 * Calls `onEscape` when Escape is pressed anywhere on the page, while the
 * component that uses the hook is mounted.
 *
 * @param {() => void} onEscape
 */
const useEscapeKey = (onEscape) => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") onEscape();
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [onEscape]);
};

export default useEscapeKey;
